import { createSelector } from 'reselect';

export const getAjaxCall = state => state.ajaxCall;

export const masked = createSelector(
  getAjaxCall,
  ({ stack }) => !!stack.find(service => service.masking)
);

export const getServicesLoading = createSelector(
  getAjaxCall,
  ({ stack }) => serviceId =>
    stack.find(service => serviceId.match(new RegExp(service.getId())))
);



// WEBPACK FOOTER //
// ./src/store/reducers/ajaxCall/selectors.js